'use client';
import React from 'react';
import { Box, Stack } from '@mui/material';
import Image from 'next/image';
import { ImageObj } from '@custom-types/ImageObj.types';
import type { SplideProps } from '@splidejs/react-splide';
import SplideSlider from '@components/SplideSlider';
import SVGIcons from '@components/SVGIcon';
import cn from './style.module.scss';
interface WildsSingleGalleryProps {
  CarouselBackgroundImage: any;
  t: any;
  galleryCarouselSlider: Array<ImageObj>;
  slideClipImage: ImageObj;
}
const wildsLaunchCarouselSettings: SplideProps['options'] = {
  type: 'loop',
  autoplay: true,
  perPage: 3,
  perMove: 1,
  interval: 2000,
  drag: false,
  pauseOnHover: false,
  breakpoints: {
    1024: {
      focus: 'center',
      padding: '50px',
      perPage: 1,
      perMove: 1,
    },
  },
};

export default function WildsLaunchCarousel(props: WildsSingleGalleryProps) {
  const { t } = props;
  return (
    <Box component="section" className={cn.wildsSingleGallery}>
      <Box className={cn.wildsGalleryBackground}>
        <Image
          src={props.CarouselBackgroundImage.url}
          alt="Wilds Launch Carousel - Carousel Background Image"
          width={768}
          height={768}
        />
      </Box>
      <Box component="div" className={cn.wildsGalleryInner}>
        <Stack className={cn.wildsGallerySlider}>
          <SplideSlider
            options={wildsLaunchCarouselSettings}
            showArrows
            arrowsClassName={cn.wildLaunchSliderArrows}
            nextClassName={cn.wildLaunchSliderNext}
            prevClassName={cn.wildLaunchSliderPrev}
            nextArrow={<SVGIcons type="graphic-arrow-right-svg" />}
            prevArrow={<SVGIcons type="graphic-arrow-left-svg" />}
            className="wildLaunchSlider"
          >
            {props.galleryCarouselSlider.map((image, index) => (
              <Box component="div" key={index} className={cn.wildsSingleSlider}>
                <Box
                  component="picture"
                  key={index}
                  className={cn.sliderGalleryElement}
                >
                  <Box
                    component="div"
                    className={cn.sliderGalleryElement__image}
                  >
                    <Image
                      src={image.url}
                      alt={`Wilds Launch Carousel - Gallery Carousel Slider ${index + 1}`}
                      layout="responsive"
                      width={600}
                      height={400}
                    />
                  </Box>
                  <Box
                    component="div"
                    className={cn.sliderGalleryElement__graphics}
                    sx={{
                      backgroundImage: `url(${props.slideClipImage.url})`,
                    }}
                  />
                </Box>
              </Box>
            ))}
          </SplideSlider>
        </Stack>
      </Box>
    </Box>
  );
}
